import { render, staticRenderFns } from "./vReportsHeader.vue?vue&type=template&id=685a33e0&"
import script from "./vReportsHeader.vue?vue&type=script&lang=js&"
export * from "./vReportsHeader.vue?vue&type=script&lang=js&"
import style0 from "./vReportsHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports